import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Auth } from './auth.models';
import {
  LoginPayload,
  RegisterPayload,
  ResetPasswordPayload,
  ConfirmNewPasswordPayload,
} from '@modules/core/interfaces';

export const AuthorizationActions = createActionGroup({
  source: 'Authorization',
  events: {
    Login: props<{ payload: LoginPayload }>(),
    Register: props<{ payload: RegisterPayload }>(),
    Logout: emptyProps(),
    'Reset Password': props<{ payload: ResetPasswordPayload }>(),
    'Confirm New Password': props<{ payload: ConfirmNewPasswordPayload }>(),
    'Verify Reset Password': emptyProps(),
    'Refresh Auth Token': emptyProps(),
    'Redirect To Login': emptyProps(),
    'Redirect To Forgot password': emptyProps(),
    'Redirect To Register': emptyProps(),
    'Redirect To Guest': emptyProps(),
  },
});

export const AuthorizationApiActions = createActionGroup({
  source: 'Authorization API',
  events: {
    'Login Success': props<{ auth: Auth }>(),
    'Login Failure': emptyProps(),
    'Register Success': props<{ auth: Auth }>(),
    'Register Failure': emptyProps(),
    'Reset Password Success': emptyProps(),
    'Reset Password Failure': emptyProps(),
    'Confirm New Password Success': emptyProps(),
    'Confirm New Password Failure': emptyProps(),
    'Verify Reset Password Success': emptyProps(),
    'Verify Reset Password Failure': emptyProps(),
    'Refresh Auth Token Success': props<{ auth: Auth }>(),
    'Refresh Auth Token Failure': emptyProps(),
  },
});

export const AuthorizationLocalStorageActions = createActionGroup({
  source: 'Authorization Local Storage',
  events: {
    'Load Auth Token': emptyProps(),
    'Set Auth Token': props<{ auth: Auth }>(),
  },
});
